/**
 * Spain while it runs NO Telegram bot (`messaging.telegram: false` in
 * `es.public.ts`, until the owner creates one in BotFather): the `es.ts`
 * sentences that promise Telegram on a surface that renders anyway, said
 * without it. Merged over `es` in `i18n/index.ts` exactly then — the day the
 * bot exists the flag flips and es.ts's own wording («por email o en
 * Telegram») comes back untouched. Same mechanism as `ru.kz.ts`.
 *
 * Only keys that RENDER with the bot off belong here (audited 2026-10-19). The
 * bot, login and connect surfaces are hidden by `VITE_TELEGRAM_BOT_USERNAME`
 * being unset; the invoice flow, pay links and yearly plans never reach a
 * Stripe deployment; the onboarding checklist row and the dashboard switch row
 * are hidden by the flag itself. Every key must exist in `es.ts` with the same
 * `{{tokens}}` (`es-no-telegram.test.ts`).
 */
export const esNoTelegram: Record<string, string> = {
  // Region hub intro (prerendered).
  'region.intro':
    'Licitaciones y contratos públicos en {{region}}: ahora hay {{count}} abiertas. De cada una tienes el presupuesto, el plazo de presentación y un resumen en español. Filtra por categoría, guarda la búsqueda y recibe las nuevas licitaciones por email.',
  // Category hub intro (prerendered).
  'category.intro':
    '«{{category}}» es uno de los sectores de la contratación pública en España. Ahora el catálogo tiene {{count}} licitaciones vigentes de esta categoría: de cada una se indica el presupuesto base, el plazo de presentación y un resumen en español. Elige la comunidad autónoma en el catálogo, guarda la búsqueda y recibe las nuevas licitaciones por email.',
  // Register, an Apple address: there is no «entra con Telegram más arriba».
  'register.icloudSpam':
    'iCloud Mail suele mandar nuestros emails a «Correo no deseado»: revisa esa carpeta y marca el mensaje como «No es correo no deseado».',
  // Home / catalog meta description and the JSON-LD Organization.description.
  'seo.catalog.description':
    'Catálogo de licitaciones públicas de España: contratos vigentes, resúmenes en español, filtros por comunidad autónoma y categoría, y alertas por email, en {{brand}}.',
  // Search with no results.
  'search.empty.body':
    'Ahora mismo no hay ningún lote así en el catálogo. Suscríbete y te avisaremos por email el mismo día en que se publique.',
  // The «Business» card on /plans.
  'plans.business.telegram': 'Cada miembro del equipo tiene sus propias búsquedas y alertas',
  // /about (prerendered).
  'about.feature.alerts.title': 'Alertas por email',
  // The lot card's Pro wall, guest CTA.
  'tender.gate.guest': 'Regístrate gratis: búsquedas guardadas y alertas por email',
  // Onboarding, the manual category picker.
  'onboarding.categories.desc': 'Nuevas licitaciones y alertas por email del sector que elijas.',
  // Catalogue nudge for an account with no saved search.
  'catalog.nudge.compact':
    'Elige una categoría y guárdala: las nuevas licitaciones te llegarán por email.',
  // Account summary, alerts off: the only channel is e-mail.
  'settings.summary.alertsOffHint': 'Sin alertas por email',
};
